import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentGateway from "../../../../_shared/PaymentGateway/PaymentGateway";
import SubFooter from "../../../../_shared/subFooter/subFooter";
import travel from "../../../../assets/images/travel.svg";
import worldcup from "../../../../assets/images/worldcup.svg";
import { config as globalConfig } from "../../../../config";
import * as globalUtils from "../../../../helpers/utils";
import { travelActions } from "../../../../redux/actions";
import { updateLoading, updateLoggedInUser } from "../../../../redux/actions/renewal";
import { UpdateQuotation, updateTravelGoogleTaggingData, updateTravelQuotation, setIsLoggedIn, updateTravelDetails, setLoading } from "../../../../redux/actions/travel";
import {
  getApplePayPaymentsAPI,
  getApplePaySessionAPI,
  getPaymentOptionsTamara,
} from "../../../../services/common";
import {
  createTamaraSession,
  getCardPayment,
  getSadadFlightDelayPayment,
  getSadadPayment,
  getQuotationDetails
} from "../../../../services/payment-service";
import config from "../../helpers/config";
import TravelPaymentGatewayStyleWrapper from "./style";
import { searchQuotation, travelPolicyDocument } from "../../../../services/travel-service";
import { Button } from "primereact/button";

const TravelPaymentGateway = (props) => {
  const navigate = useNavigate();
  const [payLoading, setPayLoading] = useState(false);
  const [showTamra, setShowTamra] = useState(true);
  const [splitPayment, setSplitPayment] = useState();
  const [optionsTamara, setOptionsTamara] = useState();
  let travelQuotation = useSelector((state) => state.travel.travelQuotation);
  let travelDetails = useSelector((state) => state.travel.travelDetails);
  // Check if Redux state is null or undefined, then fallback to localStorage
  if (!travelQuotation || Object.keys(travelQuotation).length === 0) {
    const localStorageQuotation = localStorage.getItem("travelQuotation");
    if (localStorageQuotation) {
      try {
        travelQuotation = JSON.parse(localStorageQuotation);
      } catch (error) {
        console.error("Error parsing travelQuotation from localStorage:", error);
      }
    }
  }

  if (!travelDetails || Object.keys(travelDetails).length === 0) {
    const localStorageDetails = localStorage.getItem("travelDetails");
    if (localStorageDetails) {
      try {
        travelDetails = JSON.parse(localStorageDetails);
      } catch (error) {
        console.error("Error parsing travelDetails from localStorage:", error);
      }
    }
  }



  const flightDelayQuotation = JSON.parse(
    localStorage.getItem("flightDelayQuotation")
  );
 
  const { isWorldcup, isLoggedIn } = useSelector((state) => state.travel);
  const { travelGoogleTaggingData, businessLine } = useSelector(
    (state) => state.travel
  );
  const quotationDetails = useSelector((state) => state.renewal.quotationDetails);
  const LocalQuotationNumber = localStorage.getItem("QuotationNumber");
  const dispatch = useDispatch();
  const toast = useRef(null);
  const location = useLocation();
  const { t, i18n } = props;

  // Pay Your Quote on Travel
  const params = new URLSearchParams(location.search);
  const travelDetailsFromLocalStorage = JSON.parse(localStorage.getItem("travelDetails")) || {};
  const EncryptedID = window.btoa(travelDetails?.nationalId || travelDetailsFromLocalStorage.id_no || '');
  const EncryptedDOB = window.btoa(travelDetails?.year || (travelDetailsFromLocalStorage.dob && travelDetailsFromLocalStorage.dob.substring(0, 4)) || '');
  const selectedlang = i18n.resolvedLanguage === "ar" ? "ar" : "en";
  const decryptedID = window.atob(params.get("id"));
  const decryptedDOB = window.atob(params.get("dob"));
  const payment = params.get("payment");
  function ensureWWWPrefix(url) {
    if (url.startsWith("https://tawuniya.com/")) {
      if (!url.startsWith("https://www.")) {
        url = "https://www." + url.substring("https://".length);
      }
    }
    return url;
  }

  useEffect(() => {
    if (decryptedID && decryptedDOB && payment) {
      dispatch(setIsLoggedIn(true));

      const flattenObject = (obj) => {
        let result = {};

        for (let key in obj) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            result = {
              ...result,
              ...flattenObject(obj[key]),
            };
          } else {
            result[key] = obj[key];
          }
        }

        return result;
      };

      const getQuoteDetailsPayload = {
        IDNO: decryptedID,
        languageCode: selectedlang,
        DOB: decryptedDOB,
        channelCode: "P",
      };

      searchQuotation(getQuoteDetailsPayload)
      .then((response) => {
        dispatch(setLoading(true));
          if (response.data.Status === "Success") {
            dispatch(updateTravelQuotation(flattenObject(response.data)));
            dispatch(updateTravelDetails(flattenObject(response.data)));
            localStorage.setItem("travelDetails", JSON.stringify(flattenObject(response.data)));
            dispatch(setLoading(false));
          } else if (response.resultCode && response.resultCode !== "S") {
            if (response.resultCode === "v") {
              // Handle result code 'v' here
              // For example, show a warning or take appropriate action
            } else {
              // Handle other result codes here
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: response.resultMessage,
                life: 6000,
              });
            }
          }
        })
        .catch((e) => {
          dispatch(setLoading(false));
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    }
  }, [decryptedID, decryptedDOB, payment]);
    
  let RedirectFailedURl = `${ensureWWWPrefix(globalConfig.redirectDomainUrl)}/travel/payment` + 
    "?id=" +
    EncryptedID +
    "&dob=" +
    EncryptedDOB +
    "&lang=" +
    selectedlang +
    "&payment=true"

  // REBRANDING COLORS
  let businessColor = globalUtils.BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === globalUtils.BUSINESS_LINE_PATHS.STC)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.STC;

  useEffect(() => {
    // window.lmSMTObj.page(location.pathname, {
    //   path: location.pathname,
    //   language: globalUtils.isArabic(i18n.language) ? "Arabic" : "English",
    //   referrer: document.referrer,
    //   title: document.title,
    //   url: document.URL,
    //   search: "",
    // });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "payment_initiate",
      ecommerce: {
        funnel_step: "step_7",
        step_name: "travel_inusurance_new_payment_initiate",
        items: [
          {
            item_name: "Travel Insurance New",
            item_category: "PNC Insurance",
            item_class: "Individual",
          },
        ],
      },
    });
  }, []);

  useEffect(() => {
    if (travelQuotation?.GrandTotal) {
      dispatch(updateLoading(false));
    } else {
      dispatch(updateLoading(true));
    }
  }, [travelQuotation, dispatch]);

  const getTargetQuotation = () => {
    switch (travelDetails?.productCode) {
      case "FD":
        const item = flightDelayQuotation?.paymentDetails.find(
          (ele) => ele.amountType === "GRNDTOT"
        );
        return {
          premium: item.amountValue,
          quotationNumber: flightDelayQuotation?.quotationCode,
          systemId: "FLIGHTDELAY",
        };
      case "TR-FD":
        return {
          premium: travelQuotation?.GrandTotal,
          quotationNumber: travelQuotation?.QuotationNumber || travelDetails.quotationNumber,
          systemId: "TRVLFD",
        };
      case "TR-CD":
        return {
          premium: travelQuotation?.GrandTotal,
          quotationNumber: travelQuotation?.QuotationNumber || travelDetails.quotationNumber,
          systemId: "TRVL",
        };
      default:
        return {
          premium: travelQuotation?.GrandTotal || travelDetails?.GrandTotal,
          quotationNumber: travelQuotation?.QuotationNumber || travelDetails.quotationNumber,
          systemId: "TRVL",
        };
    }
  };

  const forGoogleTagging = (paymentMethod = "") => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "add_payment_info",
      ecommerce: {
        funnel_step: "step_8",
        step_name: "travel_insurance_new_add_payment_info",
        items: [
          {
            item_name: "Travel Insurance New",
            item_category: "PNC Insurance",
            item_class: "Individual",
            travelling_to: travelGoogleTaggingData?.travelling_to,
            coverage_type: travelGoogleTaggingData?.travelling_to,
            travelling_with_family:
              travelGoogleTaggingData?.travelling_with_family,
            travelling_with_friends:
              travelGoogleTaggingData?.travelling_with_family,
            num_travellers: +travelGoogleTaggingData?.num_travellers,
            num_days: +travelGoogleTaggingData?.num_days,
            coupon: travelGoogleTaggingData?.coupon,
            fursan_membership: travelGoogleTaggingData?.fursan_mempership,
            selected_payment_method: paymentMethod,
            items: [
              {
                name: travelGoogleTaggingData?.itemName,
                id: travelGoogleTaggingData?.travelling_to_id,
                price: parseFloat(travelGoogleTaggingData?.itemPrice),
              },
            ],
          },
        ],
      },
    });
  };

  async function hash(email) {
    const utf8 = new TextEncoder().encode(email);
    const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((bytes) => bytes.toString(16).padStart(2, "0"))
      .join("");
    return hashHex;
  }

  const purchasesTagging = (payType, transaction_id) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        transaction_id: transaction_id,
        value: parseFloat(travelGoogleTaggingData?.itemPrice),
        tax: parseFloat(travelGoogleTaggingData?.tax),
        shipping: 0.0,
        currency: "SAR",
        coupon: travelGoogleTaggingData?.coupon,
        payment_method: payType,
        funnel_step: "step_9",
        step_name: "travel_insurance_new_purchase",
        items: [
          {
            item_id: travelGoogleTaggingData?.travelling_to_id,
            item_variant: travelGoogleTaggingData?.travelling_to_sub_id,
            price: parseFloat(travelGoogleTaggingData?.itemPrice),
            quantity: 1,
            item_name: "Travel Insurance New",
            item_category: "PNC Insurance",
            item_class: "Individual",
            coverage_type: travelGoogleTaggingData?.travelling_to,
            travelling_to: travelGoogleTaggingData?.travelling_to,
            travelling_with_family:
              travelGoogleTaggingData?.travelling_with_family,
            travelling_with_friends:
              travelGoogleTaggingData?.travelling_with_family,
            num_travellers: +travelGoogleTaggingData?.num_travellers,
            num_days: +travelGoogleTaggingData?.num_days,
            coupon: travelGoogleTaggingData?.coupon,
            fursan_membership: travelGoogleTaggingData?.fursan_mempership,
            sha_256_email: hash(travelGoogleTaggingData?.email),
            sha_256_phone: hash(
              globalUtils.prepareMobileNumber(travelDetails.contactNumber || travelDetails.mobileNumber)
            ),
            policy_id: travelQuotation?.QuotationNumber,
          },
        ],
      },
    });
  };

  const applePayHandler = () => {
    const quote = getTargetQuotation();
    const temp = JSON.parse(localStorage.getItem("travelQuotation")) || travelDetailsFromLocalStorage
    try {
      setPayLoading(false);
      var request = {
        countryCode: "SA",
        currencyCode: "SAR",
        supportedNetworks: ["masterCard", "visa", "mada", "discover", "amex"],
        merchantCapabilities: ["supports3DS"], // [ 'supports3DS', 'supportsCredit', 'supportsDebit' ],
        total: {
          label: "Motor Insurance",
          amount: (quote.premium ? quote.premium : temp.GrandTotal).toString(),
        },
      };
      var appleSession = new window.ApplePaySession(12, request);
      appleSession.onvalidatemerchant = async (event) => {
        let requestData = {
          sessionRequest: {
            systemId: "TRVL",
            domain: window.location.hostname,
            customer: {
              idNo: travelDetails.nationalId || travelDetails.id_no,
              mobile: globalUtils.prepareMobileNumber(
                travelDetails.contactNumber || travelDetails.mobileNumber
              ),
              email: travelDetails.email,
              passportNo: "",
            },
            quote: {
              amount: quote.premium ? quote.premium : temp.GrandTotal,
              quotationNo: quote.quotationNumber
                ? quote.quotationNumber || travelDetails.quotationNumber
                : temp.QuotationNumber || travelDetails.quotationNumber,
              policyNo: "",
            },
            lang: globalUtils.getOneLetterLanguageCode(props.i18n.language),
            channelCode: "PORTAL",
          },
        };
        //API Call
        getApplePaySessionAPI(requestData)
          .then((response) => {
            if (response?.data?.sessionResponse?.resultCode === "S") {
              const sessionData =
                response?.data?.sessionResponse?.sessionDetails;
              appleSession.completeMerchantValidation(sessionData);
            } else {
              const resultMessage =
                response?.data?.sessionResponse?.resultMessage ||
                "Sorry for not complete your request.";
              appleSession.abort();
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: resultMessage,
                life: 6000,
              });
            }
          })
          .catch((error) => {
            appleSession.abort();
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail:
                error?.message || "There Are Technical Issue In First Step.",
              life: 6000,
            });
          });
      };

      appleSession.onpaymentauthorized = async (event) => {
        const applePaymentTokenData = event.payment.token.paymentData;
        const requestData = {
          paymentRequest: {
            systemId: "TRVL",
            domain: window.location.hostname,
            customer: {
              idNo: travelDetails.nationalId || travelDetails.id_no,
              mobile: globalUtils.prepareMobileNumber(
                travelDetails.contactNumber || travelDetails.mobileNumber
              ),
              email: travelDetails.email,
              passportNo: "",
            },
            quote: {
              amount: quote.premium ? quote.premium : temp.GrandTotal,
              quotationNo: quote.quotationNumber
                ? quote.quotationNumber || travelDetails.quotationNumber
                : temp.QuotationNumber || travelDetails.quotationNumber,
              policyNo: "",
            },
            token: {
              version: applePaymentTokenData.version,
              data: applePaymentTokenData.data,
              signature: applePaymentTokenData.signature,
              header: {
                ephemeralPublicKey:
                  applePaymentTokenData.header.ephemeralPublicKey,
                publicKeyHash: applePaymentTokenData.header.publicKeyHash,
                transactionId: applePaymentTokenData.header.transactionId,
              },
            },
            lang: globalUtils.getOneLetterLanguageCode(props.i18n.language),
            channelCode: "PORTAL",
          },
        };
        //API CALL
        getApplePayPaymentsAPI(requestData)
          .then((resonseData) => {
            if (
              resonseData?.data?.paymentResponse?.resultCode == "S" &&
              resonseData?.data?.paymentResponse?.policyDetails?.policyNumber
            ) {
              appleSession.completePayment(
                window.ApplePaySession.STATUS_SUCCESS
              );
              const successPolicyNumber =
                resonseData?.data?.paymentResponse?.policyDetails?.policyNumber;
              window.localStorage.setItem(
                "travelCred",
                JSON.stringify(travelGoogleTaggingData)
              );
              localStorage.setItem("policyNoOld", successPolicyNumber);
              console.log(resonseData?.data);
              purchasesTagging("ApplePay", successPolicyNumber);
              window.location.href = businessLine
                ? `${process.env.REACT_APP_REDIRECT_URL}/${businessLine}/travel/summary`
                : `${process.env.REACT_APP_REDIRECT_URL}/travel/summary`;
            } else {
              appleSession.completePayment(
                window.ApplePaySession.STATUS_FAILURE
              );
              const resultMessage =
                resonseData?.data?.paymentResponse?.resultMessage ||
                "Sorry for not complete your payment request.";
              appleSession.abort();
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: resultMessage,
                life: 6000,
              });
              // window.lmSMTObj.track("purchaseCompleted", {
              //   paymentSuccessful: "Fail",
              //   productName: "Motor",
              //   subProductName: quotationDetails?.productCode,
              //   price: +quotationDetails?.premium,
              //   currency: "SAR",
              // });
              // window.location.href = `${window.location.hostname.includes('telebit') ? '/#' : '/product/#'}/motor/failed`;
            }
          })
          .catch((error) => {
            appleSession.completePayment(window.ApplePaySession.STATUS_FAILURE);
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail:
                error?.message || "There Are Technical Issue In Second Step.",
              life: 6000,
            });
            // window.lmSMTObj.track("purchaseCompleted", {
            //   paymentSuccessful: "Fail",
            //   productName: "Motor",
            //   subProductName: quotationDetails?.productCode,
            //   price: +quotationDetails?.premium,
            //   currency: "SAR",
            // });
            // window.location.href = `${window.location.hostname.includes('telebit') ? '/#' : '/product/#'}/motor/failed`;
          });
      };

      appleSession.oncancel = function (event) {
        //console.log('oncancel : ', event);
        //const sessionErrorCode = event.sessionError.code;
        //  console.log('sessionErrorCode 10 : ', sessionErrorCode);
        //  if (sessionErrorCode) {
        //   let defaultMsg = 'Apple Pay Session Error Code (' + sessionErrorCode + ').';
        //   if (sessionErrorCode === 'shippingContactInvalid') {
        //     defaultMsg = 'The code that indicates that the shipping address or contact information is invalid or missing.';
        //   } else if (sessionErrorCode === 'billingContactInvalid') {
        //     defaultMsg = 'The code that indicates that the billing address information is invalid or missing.';
        //   } else if (sessionErrorCode === 'addressUnserviceable') {
        //     defaultMsg = 'The code that indicates that the merchant can’t provide service to the shipping address.';
        //   } else if (sessionErrorCode === 'couponCodeInvalid') {
        //     defaultMsg = 'The code that indicates an invalid coupon.';
        //   } else if (sessionErrorCode === 'couponCodeExpired') {
        //     defaultMsg = 'The code that indicates an expired coupon.';
        //   } else if (sessionErrorCode === 'unknown') {
        //     defaultMsg = 'The code that indicates an unknown but nonfatal error occurred during payment processing. The user can attempt authorization again.';
        //   }
        //   toast.current.show({
        //     severity: "error",
        //     summary: "Apple Pay Error",
        //     detail: defaultMsg,
        //     life: 10000,
        //   });
        //  }
        //  setaAplePayData({
        //   sessionErrorCode: sessionErrorCode,
        //   oncancel: event
        // });
      };
      appleSession.begin();
    } catch (e) {
      //console.log("startApple-error : ",e);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: e?.message || "There Are Issue.",
        life: 6000,
      });
    }
  };

  const creditCardTokenHandler = (token) => {
    const quote = getTargetQuotation();
    const temp = JSON.parse(localStorage.getItem("travelQuotation")) || travelDetailsFromLocalStorage;
    const travelDetails = JSON.parse(localStorage.getItem("travelDetails"));
    travelGoogleTaggingData.email = travelDetails.email;
    travelGoogleTaggingData.phone = globalUtils.prepareMobileNumber(
      travelDetails.contactNumber || travelDetails.mobileNumber
    );
    travelGoogleTaggingData.selected_payment_method = "Credit Card";

    setPayLoading(true);
    const data = {
      passportNo: "",
      amount: quote.premium ? quote.premium : temp.GrandTotal,
      "3ds": {
        enabled: "true",
      },
      systemId: quote.systemId || "TRVL",
      mobile: globalUtils.prepareMobileNumber(travelDetails.contactNumber || travelDetails.mobileNumber),
      capture: "true",
      policyNo: "",
      source: {
        token: token,
        type: "token",
      },
      idNo: travelDetails.nationalId || travelDetails.id_no,
      quotationNo: quote.quotationNumber ? quote.quotationNumber || travelDetails.quotationNumber : temp.QuotationNumber || travelDetails.quotationNumber,
      reference: "xxxx",
      currency: "SAR",
      risk: {
        enabled: "true",
      },
      failure_url: RedirectFailedURl,
      lang: globalUtils.getOneLetterLanguageCode(props.i18n.language),
      email: travelDetails.email,
      success_url: config.paymentSuccessRedirect,
    };

    getCardPayment(data)
      .then((response) => {
        const res = response.data;
        setPayLoading(false);
        window.lmSMTObj.track("payNowClickedSecond", {
          "productName": "Property & Casualty Insurance",
          "subProductName": "Travel Insurance",
          "totalAmount": data.amount,
          "currency": "SAR",
          "paymentMethod": "Credit/DebitCard"
        })
        localStorage.setItem("productName", "Property & Casualty Insurance");
        localStorage.setItem("subProductName", "Travel Insurance");
        //for Google tagging (for user after clicking on checkout)
        forGoogleTagging("Credit Card");
        // saving in local storage
        window.localStorage.setItem(
          "travelCred",
          JSON.stringify(travelGoogleTaggingData)
        );

        window.localStorage.setItem(
          "travelCreditcardPaymentData",
          JSON.stringify({
            ...travelGoogleTaggingData,
            selected_payment_method: "Credit Card",
            isWorldcup: isWorldcup,
          })
        );

        dispatch(travelActions.setLoading(false));
        localStorage.setItem("checkoutId", res.getCardPaymentResponse.id);
        localStorage.setItem("TawunLang", i18n.language);
        window.localStorage.setItem(
          "travelCheckoutId",
          res.getCardPaymentResponse.id
        );

        // navigate(config.paymentFailedRedirect, {
        //   replace: true,
        //   state: { checkoutId: res.id},
        // });
        //console.log(res);

        purchasesTagging("Credit Card", res.getCardPaymentResponse.id);
        window.location.href = res.getCardPaymentResponse._links.redirect.href;
      })
      .catch((err) => {
        // for Google tagging (failed to checkout)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: "Travel Insurance New",
          funnel_step: "step_7",
          error_messages: JSON.stringify(err),
        });
        setPayLoading(false);
        dispatch(travelActions.setLoading(false));
        window.location.href = RedirectFailedURl;
      });
  };

  const sadadHandler = () => {

    if (travelDetails.productCode === "FD") {
      sadadFlightDelayHandler();
    } else {
      sadadTravelHandler();
    }


    window.lmSMTObj.track("payNowClickedSecond", {
      "productName": "Property & Casualty Insurance",
      "subProductName": "Travel Insurance",
      "totalAmount": getTargetQuotation().premium,
      "currency": "SAR",
      "paymentMethod": "Sadad"
    })
    localStorage.setItem("productName", "Property & Casualty Insurance");
    localStorage.setItem("subProductName", "Travel Insurance");

    // for Google tagging (for user after clicking on checkout)
    forGoogleTagging("Sadad");
    dispatch(
      updateTravelGoogleTaggingData({ selected_payment_method: "Sadad" })
    );
  };

  const sadadFlightDelayHandler = () => {
    const quote = getTargetQuotation();
    setPayLoading(true);
    const data = {
      flightDelayRequest: {
        channelCode: businessLine ? "3" : "2",
        idNo: travelDetails.nationalId || travelDetails.id_no,
        languageCode: globalUtils.getOneLetterLanguageCode(props.i18n.language),
        quotationNo: quote.quotationNumber || travelDetails.quotationNumber,
      },
      language: globalUtils.getOneLetterLanguageCode(props.i18n.language),
      mmRequest: null,
      motorRequest: null,
      source: "FLIGHTDELAY",
      trvlRequest: null,
      vvRequest: null,
    };

    getSadadFlightDelayPayment(data)
      .then((response) => {
        const res = response.data;
        setPayLoading(false);
        dispatch(travelActions.setLoading(false));
        if (res.resultCode === "S") {
          // window.lmSMTObj.track("purchaseCompleted", {
          //   "paymentSuccessful": "true",
          //   "productName": "Property & Casualty Insurance",
          //   "subProductName": "Travel Insurance"
          // })
          navigate(
            businessLine
              ? `/${businessLine}${config.sadadSuccessRedirect}`
              : config.sadadSuccessRedirect,
            {
              replace: true,
              state: {
                billNumber: res.billNo,
                billExpiryDate: res.billExpiryDate,
                amount: getTargetQuotation().premium,
                policyNumber: res.policyNumber,
              },
            }
          );
        } else {
          // window.lmSMTObj.track("purchaseCompleted", {
          //   "paymentSuccessful": "false",
          //   "productName": "Property & Casualty Insurance",
          //   "subProductName": "Travel Insurance"
          // })
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: res.resultMessage,
            life: 6000,
          });
          purchasesTagging("Sadad", res.billNo);

          navigate(
            businessLine
              ? `/${businessLine}${config.sadadFailedRedirect}`
              : config.sadadFailedRedirect,
            { replace: true }
          );
        }
      })
      .catch((err) => {
        // window.lmSMTObj.track("purchaseCompleted", {
        //   "paymentSuccessful": "false",
        //   "productName": "Property & Casualty Insurance",
        //   "subProductName": "Travel Insurance"
        // })
        setPayLoading(false);
        dispatch(travelActions.setLoading(false));
        navigate(
          businessLine
            ? `/${businessLine}${config.sadadFailedRedirect}`
            : config.sadadFailedRedirect,
          { replace: true }
        );
      });
  };

  const sadadTravelHandler = () => {
    setPayLoading(true);
    const data = {
      source: "TRVL",
      trvlRequest: {
        endtType: "PSL",
        Quotation: getTargetQuotation().quotationNumber || travelDetails.quotationNumber || LocalQuotationNumber,
        IDNO: travelDetails.nationalId || travelDetails.id_no,
        languageCode: globalUtils.getOneLetterLanguageCode(props.i18n.language),
        channelCode: businessLine ? "3" : "2",
      },
      source: getTargetQuotation().systemId,
    };
    console.log(data,"SADAD_DATA")
    getSadadPayment(data)
      .then((response) => {
        const res = response.data;
        setPayLoading(false);
        dispatch(travelActions.setLoading(false));
        if (res.resultCode === "S") {
          // window.lmSMTObj.track("purchaseCompleted", {
          //   "paymentSuccessful": "true",
          //   "productName": "Property & Casualty Insurance",
          //   "subProductName": "Travel Insurance"
          // })
          purchasesTagging("Sadad", res.billNo);

          navigate(
            businessLine
              ? `/${businessLine}${config.sadadSuccessRedirect}`
              : config.sadadSuccessRedirect,
            {
              replace: true,
              state: {
                billNumber: res.billNo,
                billExpiryDate: res.billExpiryDate,
                amount: getTargetQuotation().premium,
                policyNumber: res?.policyNumber,
              },
            }
          );
        } else {
          // window.lmSMTObj.track("purchaseCompleted", {
          //   "paymentSuccessful": "false",
          //   "productName": "Property & Casualty Insurance",
          //   "subProductName": "Travel Insurance"
          // })
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: res.resultMessage,
            life: 6000,
          });
          // window.location.href = config.paymentFailedRedirect;
          navigate(
            businessLine
              ? `/${businessLine}${config.sadadFailedRedirect}`
              : config.sadadFailedRedirect,
            { replace: true }
          );
        }
      })
      .catch((err) => {
        // window.lmSMTObj.track("purchaseCompleted", {
        //   "paymentSuccessful": "false",
        //   "productName": "Property & Casualty Insurance",
        //   "subProductName": "Travel Insurance"
        // })
        setPayLoading(false);
        dispatch(travelActions.setLoading(false));
        navigate(
          businessLine
            ? `/${businessLine}${config.sadadFailedRedirect}`
            : config.sadadFailedRedirect,
          { replace: true }
        );
      });
  };

  const tamaraCreateSession = () => {
    const quote = getTargetQuotation();
    const temp = JSON.parse(localStorage.getItem("travelQuotation"));
    const data = {
      quotationNumber: quote.quotationNumber
        ? quote.quotationNumber
        : temp.QuotationNumber,
      totalAmount: quote.premium ? quote.premium : temp.GrandTotal,
      systemId: "TR",
      endorsementType: "PSL",
      mobileNumber: globalUtils.prepareMobileNumber(
        travelDetails.contactNumber || travelDetails.mobileNumber
      ),
      langCode: globalUtils.getOneLetterLanguageCode(props.i18n.language),
      links: {
        success: { url: config.paymentSuccessRedirect + "?" },
        failure: { url: RedirectFailedURl + "?" },
      },
      idNumber: travelDetails.nationalId || travelDetails.id_no,
      email: travelDetails.email,
      channelCode: "Portal",
      tmx: null,
    };

    window.lmSMTObj.track("payNowClickedSecond", {
      "productName": "Property & Casualty Insurance",
      "subProductName": "Travel Insurance",
      "totalAmount": quote.premium ? quote.premium : temp.GrandTotal,
      "currency": "SAR",
      "paymentMethod": "Tamara"
    })

    createTamaraSession(data)
      .then((response) => {
        const res = response.data;
        if (res.resultCode === "S") {
          // window.lmSMTObj.track("purchaseCompleted", {
          //   "paymentSuccessful": "true",
          //   "productName": "Property & Casualty Insurance",
          //   "subProductName": "Travel Insurance"
          // })
          localStorage.setItem("tamaraResponse", JSON.stringify(res));
          purchasesTagging("Tamara", res.refId);
          window.location.replace(res.redirectUrl);
        } else {
          // window.lmSMTObj.track("purchaseCompleted", {
          //   "paymentSuccessful": "false",
          //   "productName": "Property & Casualty Insurance",
          //   "subProductName": "Travel Insurance"
          // })
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: res.resultMessage,
            life: 6000,
          });
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: "Medical Malpractice New",
            funnel_step: "step_7",
            error_messages: "Tamara Payment Failed",
          });
        }
      })
      .catch((err) => {
        // window.lmSMTObj.track("purchaseCompleted", {
        //   "paymentSuccessful": "false",
        //   "productName": "Property & Casualty Insurance",
        //   "subProductName": "Travel Insurance"
        // })
        window.location.href = config.paymentFailedRedirect;
      })
      .finally(() => {});
  };

  const getPaymentOptions = () => {
    const result = [
      globalConfig.paymentOptions.CREDIT_CARD,
      globalConfig.paymentOptions.TAMARA,
      globalConfig.paymentOptions.APPLE,
    ];
    if (travelDetails.productCode !== "TR-FD") {
      result.push(globalConfig.paymentOptions.SADAD);
    }
    return result;
  };

  const generatePolicyHandler = ()=>{

    dispatch(setLoading(true));
    
    const quote = getTargetQuotation();
    const temp = JSON.parse(localStorage.getItem("travelQuotation"));

    const request = {
      "idNum": travelDetails.nationalId || travelDetails.id_no,
      "quotationNumber": quote.quotationNumber
      ? quote.quotationNumber
      : temp.QuotationNumber,
      "lang": globalUtils.getOneLetterLanguageCode(props.i18n.language)
  }
    travelPolicyDocument(request).then(
      res => {

        localStorage.setItem("checkoutId", "");
        localStorage.setItem("TawunLang", i18n.language);
        window.localStorage.setItem(
          "travelCheckoutId",
          ""
        );

        navigate(
          businessLine
            ? `/${businessLine}/travel/summary`
            : '/travel/summary ',
          {
            replace: true,
            state: {
              data: res.data,
              policyNumber: res.data.policyNo,
            },
          }
        );
             
      }
    ).catch(
      err => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: err.message,
          life: 6000,
        });
      }
    ).finally(
      e=>{dispatch(setLoading(false));}
    )
  }

  useEffect(() => {
    // for tamara options
    const tamaraRequest = {
      idNumber: travelQuotation?.IDNO || travelDetails?.nationalId || travelQuotation?.id_no,
      quotationNumber: travelQuotation?.QuotationNumber || travelQuotation?.quotationNumber,
      totalAmount: travelQuotation?.GrandTotal,
      systemId: "TRVL",
      mobileNumber: globalUtils.prepareMobileNumber(travelDetails?.contactNumber || travelDetails?.mobileNumber, true),
      email: travelDetails?.email,
      langCode: globalUtils.getOneLetterLanguageCode(props.i18n.language),
    };

    // Set loading state to true
    dispatch(setLoading(true));

    getPaymentOptionsTamara(tamaraRequest)
      .then(res => {
        const response = res.data;
        if (response.resultCode === "S") {
          setOptionsTamara([...response.paymentOptions.available_payment_labels]);
          setSplitPayment(response.paymentOptions.available_payment_labels[0].instalment);
          setShowTamra(response.paymentOptions?.has_available_payment_options)
        }
        else{
          setShowTamra(false)
        }
      })
      .catch(error => {
        console.error("Error fetching Tamara options:", error);
        setShowTamra(false)
      })
      .finally(() => {
        // Set loading state to false
        dispatch(setLoading(false));
      });

  }, []);

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <TravelPaymentGatewayStyleWrapper>
        <div className={`${isWorldcup ? "worldcup_payment_bg_img" : ""}`}>
          <div
            className={
              "container pt-5 " + (props.i18n.language === "ar" ? "ar" : "")
            }
          >
            {
              getTargetQuotation().premium  && 
              !+getTargetQuotation().premium ? (
                <div className="row">
                  <div className="col-md-3">
                    <h2>Generate Policy</h2>
                  </div>
                  <div className="col-md-9">
                    <div
                      className="card d-flex flex-column justify-content-center align-items-center w-100"
                      style={{ minHeight: "300px" }}
                    >
                      <h4 className="mb-3">
                        You are About to generate your Policy
                      </h4>
                      <div className="btn-group">
                        <Button
                          className="btn primary mb-3"
                          onClick={() => generatePolicyHandler()}
                          style={{ background: businessColor }}
                        >
                          Generate Policy
                        </Button>
                      </div>
                      <p>
                        You will transfer to the next page for Policy details.
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-3">
                    <h2>{props.i18n.t("choosePaymentMethod")}</h2>
                  </div>
                  <div className="col-md-9">
                    <PaymentGateway
                      creditCardToken={creditCardTokenHandler}
                      paymentOptions={getPaymentOptions()}
                      tamaraCreateSession={tamaraCreateSession}
                      sadadHandler={sadadHandler}
                      creditCardLoading={payLoading}
                      ackAgree={true}
                      totalAmount={getTargetQuotation().premium}
                      applePayHandler={applePayHandler}
                      splitPayment={splitPayment}
                      setSplitPayment={setSplitPayment}
                      optionsTamara={optionsTamara}
                      showTamra={showTamra}
                    />
                  </div>
                </div>
              )
            }
            
          </div>
        </div>
      </TravelPaymentGatewayStyleWrapper>
      <SubFooter
        hideNextBtn={true}
        priceDetails={null}
        icon={isWorldcup ? worldcup : travel}
        hideSummary={true}
        summary={[]}
        total={getTargetQuotation().premium}
        beforeTotal={
          +travelQuotation.PromotionDiscount
            ? (+travelQuotation.PromotionDiscount * 1.15).toFixed(2)
            : ""
        }
      />
    </React.Fragment>
  );
};

export default withTranslation()(TravelPaymentGateway);
